import { useEffect, useState } from 'react';

import { FormField, FormHelp, Label, Textarea } from '@zillow/constellation-10';
import { css } from '@/styled-system/css';

type Props = {
  initialValue?: string;
  isDisabled?: boolean;
  maxLength?: number;
  // eslint-disable-next-line
  onClearError?: (value?: any) => void;
  handleCaptionBlur: (value: string) => void;
};

export const TextareaHelper = ({
  initialValue = '',
  isDisabled = false,
  maxLength = 255,
  onClearError,
  handleCaptionBlur,
}: Props) => {
  const [value, setValue] = useState(initialValue);
  const [isFocused, setIsFocused] = useState(false);

  const isOverLimit = value.length > maxLength;
  const showCounter = isFocused || isOverLimit;

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleOnChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (onClearError) {
      onClearError();
    }
    setValue(e.target.value);
  };

  const handleOnBlur = () => {
    setIsFocused(false);
    handleCaptionBlur(value);
  };

  return (
    <FormField
      css={{ marginBlock: 'tight' }}
      disabled={isDisabled}
      error={isOverLimit}
      label={<Label>Caption</Label>}
      control={
        <Textarea
          aria-label="Image Description"
          value={value}
          onChange={handleOnChange}
          onFocus={() => setIsFocused(true)}
          onBlur={handleOnBlur}
          css={{ resize: 'vertical' }}
        />
      }
      description={
        <FormHelp css={showCounter ? { display: 'flex' } : undefined}>
          <span className={css({ flex: 1 })}>
            {isOverLimit ? `Caption must be ${maxLength} characters or fewer` : ''}
          </span>
          {showCounter && (
            <span
              className={css({
                whiteSpace: 'nowrap',
                flexShrink: 0,
                marginLeft: 'auto',
                paddingLeft: 'tighter',
              })}
            >
              {value.length.toLocaleString()}/{maxLength} characters
            </span>
          )}
        </FormHelp>
      }
    />
  );
};
